module.exports = __webpack_public_path__ + "static/media/CHUONGTRINHGIANGDAY-11.387293ac.png";